import type { IColorInputFieldProps, IOmit } from '@sixui/ui';
import { forwardRef } from 'react';
import {
  ColorInputField,
  HctColorPickerContent,
  HslColorPickerContent,
  Skeleton,
} from '@sixui/ui';

import { useAppQuery } from '~/lib/api/modules/Apps/hooks/useAppQuery';
import { getAppSettings } from '~/lib/appSettings';

export type ICustomColorInputFieldProps = IOmit<
  IColorInputFieldProps,
  'colorPickerRenderer'
> & {
  appId?: string;
  customColors?: Array<string>;
  palette?: 'regular' | 'app';
};

export const CustomColorInputField = forwardRef<
  HTMLInputElement,
  ICustomColorInputFieldProps
>(function CustomInputField(props, forwardedRef) {
  const {
    appId,
    customColors: customColorsProp,
    palette = 'app',
    ...other
  } = props;
  const appQuery = useAppQuery(appId ? { appId } : undefined);
  const loaded = !!appQuery.data || !appQuery.isLoading;
  const appSettings = getAppSettings();
  const appPrimaryColor =
    appQuery.data?.settings?.press?.env?.appThemeColorPrimary;

  const customColors = [
    ...(customColorsProp ?? []),
    appPrimaryColor ?? appSettings.theme.appDefaultPrimaryColor,
  ];

  return (
    <Skeleton loaded={loaded}>
      <ColorInputField
        {...other}
        ref={forwardedRef}
        colorPickerRenderer={(renderProps) =>
          palette === 'app' ? (
            <HctColorPickerContent
              sourceColor={appPrimaryColor}
              {...renderProps}
              customColors={[...renderProps.customColors, ...customColors]}
            />
          ) : (
            <HslColorPickerContent
              {...renderProps}
              customColors={[...renderProps.customColors, ...customColors]}
            />
          )
        }
      />
    </Skeleton>
  );
});
